export default __webpack_public_path__ + "big-img-1ad8f647606d8aee878067dd3e3336cc.png";